import { p as proxyCustomElement, H, h, c as Host } from './p-92c4a1ea.js';
import './p-a57042e3.js';
import { b as accessibility } from './p-756e7dc5.js';
import { a as ComponentUtils } from './p-de830ba7.js';
const tagCss = ".sc-owc-tag-h{display:-ms-inline-flexbox;display:inline-flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center;padding:var(--one-spacing-padding-5-xs) var(--one-spacing-padding-4-xs);min-width:var(--one-spacing-size-6-xs);width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;min-height:var(--one-spacing-size-s);border-radius:var(--one-spacing-radius-5-xs);gap:var(--one-spacing-gap-5-xs);-webkit-box-sizing:border-box;box-sizing:border-box;color:var(--one-color-foreground-contrast-highest);background-color:var(--one-color-background-intensity-medium);font-family:var(--one-typography-font-family);font-size:var(--one-typography-desktop-badge-font-size);line-height:var(--one-typography-desktop-badge-line-height);-webkit-font-kerning:var(--one-typography-desktop-badge-font-kerning);font-kerning:var(--one-typography-desktop-badge-font-kerning);font-weight:var(--one-text-font-weight-bold)}.sc-owc-tag-h owc-icon.sc-owc-tag{font-size:var(--one-spacing-size-2-xs)}.owc-tag--rounded.sc-owc-tag-h{border-radius:var(--one-spacing-radius-100)}.owc-tag--status-default.sc-owc-tag-h [slot=prefix].sc-owc-tag{color:inherit}.owc-tag--status-default.sc-owc-tag-h [slot=suffix].sc-owc-tag{color:inherit}.owc-tag--status-alarm.sc-owc-tag-h{color:var(--one-color-foreground-contrast-highest);background-color:var(--one-color-background-negative-base)}.owc-tag--status-alarm.sc-owc-tag-h [slot=prefix].sc-owc-tag{color:inherit}.owc-tag--status-alarm.sc-owc-tag-h [slot=suffix].sc-owc-tag{color:inherit}.owc-tag--status-warning.sc-owc-tag-h{color:var(--one-color-foreground-contrast-lowest);background-color:var(--one-color-background-warning-base)}.owc-tag--status-warning.sc-owc-tag-h [slot=prefix].sc-owc-tag{color:inherit}.owc-tag--status-warning.sc-owc-tag-h [slot=suffix].sc-owc-tag{color:inherit}.owc-tag--status-positive.sc-owc-tag-h{color:var(--one-color-foreground-contrast-highest);background-color:var(--one-color-background-positive-base)}.owc-tag--status-positive.sc-owc-tag-h [slot=prefix].sc-owc-tag{color:inherit}.owc-tag--status-positive.sc-owc-tag-h [slot=suffix].sc-owc-tag{color:inherit}.owc-tag--disabled.sc-owc-tag-h{color:var(--one-color-interaction-disabled-base);background-color:var(--one-color-interaction-disabled-intensity-lower)}.owc-tag--disabled.sc-owc-tag-h [slot=prefix].sc-owc-tag{color:inherit}.owc-tag--disabled.sc-owc-tag-h [slot=suffix].sc-owc-tag{color:inherit}.owc-tag--outlined.sc-owc-tag-h{color:var(--one-color-foreground-base);background-color:transparent;border:var(--one-spacing-outline-regular) solid var(--one-color-foreground-base)}.owc-tag--outlined.owc-tag--status-alarm.sc-owc-tag-h{color:var(--one-color-foreground-base);border-color:var(--one-color-background-negative-base)}.owc-tag--outlined.owc-tag--status-warning.sc-owc-tag-h{color:var(--one-color-foreground-base);border-color:var(--one-color-background-warning-base)}.owc-tag--outlined.owc-tag--status-positive.sc-owc-tag-h{color:var(--one-color-foreground-base);border-color:var(--one-color-background-positive-base)}.owc-tag--outlined.owc-tag--disabled.sc-owc-tag-h{color:var(--one-color-interaction-disabled-base);border-color:var(--one-color-interaction-disabled-intensity-low)}@media (forced-colors: active){.sc-owc-tag-h{color:canvastext;outline:var(--one-spacing-outline-regular) solid canvastext}.owc-tag--disabled.sc-owc-tag-h{color:graytext}.owc-tag--outlined.sc-owc-tag-h{color:canvastext;border-color:canvastext;outline:none}.owc-tag--outlined.owc-tag--disabled.sc-owc-tag-h{color:graytext;border-color:canvastext;outline:none}}";
const OwcTagStyle0 = tagCss;
const Tag = /*@__PURE__*/proxyCustomElement(class Tag extends H {
  constructor() {
    super();
    this.__registerHost();
    this.component = new ComponentUtils(this);
    this.disabled = false;
    this.rounded = false;
    this.outlined = false;
    this.status = 'default';
  }
  render() {
    const hostClasses = this.component.getHostBemClasses({
      [`status-${this.status || 'default'}`]: true,
      disabled: this.disabled,
      rounded: this.rounded,
      outlined: this.outlined
    });
    return h(Host, Object.assign({
      key: 'ce347a71953a953bffddaba9eb7201367afe9af6',
      class: hostClasses
    }, accessibility({
      role: 'status',
      aria: {
        disabled: !!this.disabled,
        live: this.disabled ? 'off' : 'polite'
      }
    })), h("slot", {
      key: '440a4a38513219bf01592d9ba2db955a3ac45e69',
      name: "prefix"
    }), h("slot", {
      key: '41aa791b37fb2fd2c9428eca1c510a60b64124ad'
    }), h("slot", {
      key: 'e1b099fb288be2285615784ce75ff039e64862f6',
      name: "suffix"
    }));
  }
  get hostElement() {
    return this;
  }
  static get style() {
    return OwcTagStyle0;
  }
}, [6, "owc-tag", {
  "disabled": [516],
  "rounded": [516],
  "outlined": [516],
  "status": [513]
}]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["owc-tag"];
  components.forEach(tagName => {
    switch (tagName) {
      case "owc-tag":
        if (!customElements.get(tagName)) {
          customElements.define(tagName, Tag);
        }
        break;
    }
  });
}
const OwcTag = Tag;
const defineCustomElement = defineCustomElement$1;
export { OwcTag, defineCustomElement };